import { CSSProperties, FC, InputHTMLAttributes } from "react"
import styles from "./TextInputField.module.scss"

type RequireAtLeastOne<T, Keys extends keyof T = keyof T> = Pick<T, Exclude<keyof T, Keys>> &
  { [K in Keys]-?: Required<Pick<T, K>> & Partial<Pick<T, Exclude<Keys, K>>> }[Keys]

interface TextInputFieldProps extends InputHTMLAttributes<HTMLInputElement> {
  isChecked?: boolean
  style: CSSProperties
  placeholder: string
  value: string
}

const TextInputField: FC<TextInputFieldProps> = ({ isChecked = true, style, placeholder, value, ...inputProps }) => {
  return (
    <input
      value={value}
      type="text"
      className={styles.inputField}
      placeholder={placeholder}
      disabled={!isChecked}
      {...inputProps}
    />
  )
}

export default TextInputField
